<template>
  <div className="login-container">
    <h1 style="text-align: center">HQM</h1>
    <v-text-field data-automationId="email" type="email" label="Email" v-model="email"></v-text-field>
    <v-text-field data-automationId="password" type="password" label="Password" v-model="password"></v-text-field>
    <v-alert data-automationId="errorMessage" v-if="error != ''" :text="error" type="error" class="errorMessage"></v-alert>
    <v-btn data-automationId="loginButton" color="primary" @click="login" class="loginButton">SIGN IN</v-btn>
  </div>
</template>

<script>
import {getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword} from 'firebase/auth';

export default {
  components: {},
  data() {
    return {
      email: '',
      password: '',
      error: ''
    }
  },
  methods: {
    async login() {
      this.error = "";
      const auth = getAuth();
      try {
        await signInWithEmailAndPassword(auth, this.email, this.password);
        // Fetch user profile from Firestore
        await this.$store.dispatch('fetchUser');
        await this.$store.dispatch('fetchUserProfile');
        const user = this.$store.getters.userProfile;
        // Redirect based on role
        if (user.role === 'super_admin' || user.role === 'company_admin') {
          this.$router.push('/chart');
        } else if (user.companyId) {
          this.$router.push(`/customer/${user.companyId}/dashboard`);
        } else {
          this.$router.push('/');
        }
      } catch (error) {
        this.error = error.message;
      }
    },
    async signUp() {
      const auth = getAuth();
      try {
        await createUserWithEmailAndPassword(auth, this.email, this.password);
        this.$router.push('/');
      } catch (error) {
        alert(error.message);
      }
    }
  }
}
</script>

<style scoped>
.login-container {
  display: block;
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 500px;
}
.loginButton{
  margin-left: auto;
  margin-right: auto;
  display: block;
}
.errorMessage {
  margin-top: 5px;
  margin-bottom: 10px;
}
/* Your CSS here */
</style>
